import type {
    Advantage,
    NavItem,
    ProcessStep,
    SiteConfig,
    TimelineEntry
} from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Markus Balle',
    tagline: 'Wirtschaftsprüfer und Steuerberater in Stuttgart-Vaihingen',
    description: 'Wirtschaftsprüfer und Steuerberater Markus Balle in Stuttgart-Vaihingen: persönliche Beratung zu Steuern, Prüfung, Buchhaltung und Existenzgründung.',
    url: getOrigin(),
    ogImage: 'https://markus-balle.cdn.modulify.website/og/markus-balle-hero.jpg'
}

export const contact = {
    practice: 'Wirtschaftsprüfung Steuerberatung',
    name: 'Markus Balle',
    fullName: 'Diplom-Kaufmann Markus Balle',
    titles: 'Wirtschaftsprüfer, Steuerberater',
    street: 'Ruppmannstraße 33A',
    zip: '70565',
    city: 'Stuttgart-Vaihingen',
    country: 'Deutschland',
    phone: {
        display: '0711 78 78 530',
        international: '+49 (0) 711 78 78 530',
        href: 'tel:+497117878530'
    },
    fax: {
        display: '0711 70 72 72 62',
        international: '+49 (0) 711 70 72 72 62'
    },
    email: 'info@markus-balle.de',
    web: 'www.markus-balle.de',
    webUrl: 'https://www.markus-balle.de',
    mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Ruppmannstra%C3%9Fe%2033A%2C%2070565%20Stuttgart',
    partner: {
        name: 'Andreas Jelden',
        title: 'Rechtsanwalt',
        since: 'Oktober 2011',
        url: 'http://www.rechtsanwalt-jelden.de/',
        label: 'www.rechtsanwalt-jelden.de'
    }
}

export const mainNavigation: NavItem[] = [
    { label: 'Leistungen', href: '/leistungen' },
    { label: 'Über mich', href: '/ueber-mich' },
    { label: 'Kontakt', href: '/kontakt' }
]

export const legalNavigation: NavItem[] = [
    { label: 'Impressum', href: '/impressum' },
    { label: 'Datenschutz', href: '/datenschutz' }
]

export const advantages: Advantage[] = [
    {
        title: '„Chef“-Betreuung',
        text: 'Ihre Anliegen bearbeite ich persönlich. Sie sprechen immer direkt mit dem Wirtschaftsprüfer und Steuerberater.'
    },
    {
        title: 'Umfassende Beratung aus einer Hand',
        text: 'Steuerberatung, Wirtschaftsprüfung, Buchhaltung und Gründungsberatung greifen ineinander, statt nebeneinander herzulaufen.'
    },
    {
        title: 'Keine wechselnden Ansprechpartner',
        text: 'Ich kenne Ihre Situation und Ihre Ziele. Sie müssen nichts zweimal erklären.'
    },
    {
        title: 'Kurze Reaktionszeiten auf Ihre Anfragen',
        text: 'Ihre Fragen bleiben nicht liegen. Sie erhalten zügig eine fundierte Rückmeldung.'
    },
    {
        title: 'Keine starren Büroöffnungszeiten',
        text: 'Termine richten sich nach Ihnen und Ihrem Kalender, nicht nach festen Sprechzeiten.'
    },
    {
        title: 'Räumliche Distanz spielt keine Rolle',
        text: 'Durch den Einsatz modernster Technologien und Software arbeiten wir auch über Entfernungen hinweg reibungslos zusammen.'
    }
]

export const timeline: TimelineEntry[] = [
    {
        year: '2000',
        title: 'Diplom-Kaufmann',
        text: 'Abschluss des Studiums der Betriebswirtschaftslehre an der Eberhard-Karls-Universität Tübingen.'
    },
    {
        year: '2005',
        title: 'Bestellung zum Steuerberater'
    },
    {
        year: '2007',
        title: 'Eigene Kanzlei',
        text: 'Seitdem berate ich als selbständiger Steuerberater in Stuttgart-Vaihingen meine Mandanten.'
    },
    {
        year: '2009',
        title: 'Bestellung zum Wirtschaftsprüfer'
    },
    {
        year: '2011',
        title: 'Bürogemeinschaft',
        text: 'Seit Oktober 2011 gemeinsam mit Herrn Rechtsanwalt Andreas Jelden.'
    }
]

export const processSteps: ProcessStep[] = [
    {
        title: 'Persönliches Gespräch',
        text: 'Gerne kläre ich mit Ihnen in einem persönlichen, unverbindlichen Gespräch, ob ich Ihren Beratungsbedarf abdecken kann.'
    },
    {
        title: 'Konkretes Angebot',
        text: 'Sie erhalten ein Angebot, das zu Ihnen passt. Die Gebühr richtet sich nach Umfang, Schwierigkeit und Bedeutung der Angelegenheit.'
    },
    {
        title: 'Persönliche Betreuung',
        text: 'Sie stehen immer im direkten Kontakt mit mir. Gemeinsam sorgen wir für eine effiziente Abwicklung Ihrer Belange.'
    }
]
